import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Wallet } from "lucide-react";
import { api } from "../lib/api";
import { useAuth } from "../context/AuthContext";

export default function BookCreditBadge() {
  const { user } = useAuth(); const [credit, setCredit] = useState(0);
  useEffect(() => { if (user) api.get("/shop/library/credit").then((r) => setCredit(r.data.book_credit || 0)).catch(() => {}); }, [user]);
  if (!user || credit <= 0) return null;
  return (
    <Link to="/shop?cat=Digital%20Books" className="h-10 px-3 inline-flex items-center gap-2 rounded-lg border border-emerald-400/50 bg-emerald-400/10 text-emerald-300 text-sm font-semibold hover:bg-emerald-400/20" title="Book credit — spend it on any booklet" data-testid="book-credit-badge">
      <Wallet className="w-4 h-4" />${credit.toFixed(2)} <span className="hidden sm:inline font-normal text-emerald-200/80">book credit</span>
    </Link>
  );
}
